/**
 * @voltxampere/ui — TRIAC BTA16 variant (Sprint 44-2, placeholder)
 *
 * PLACEHOLDER. Bidirectional thyristor; gerçek TRIAC stamp Sprint 47+
 * engine extension #4 ile aktif. Şu anki stamp'te `diode` schemaType
 * üzerinden forward-conducting davranış gösterir; gate trigger +
 * latched-on + bidirectional Sprint 47+'da gelir.
 *
 * Reference: ST BTA16-600B — TO-220AB. V_DRM = 600 V, I_T(RMS) = 16 A,
 * V_T = 1.55 V (typical at I_T = 16 A), I_GT = 50 mA. AC mains
 * switching, dimmer, motor control workhorse.
 *
 * Engine zero-diff invariant honored — canonical `diode` engine type
 * via schemaType. Inspector "TRIAC bidirectional thyristor — Sprint 47+
 * scope" warning ileride eklenir.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { diode } from "../diode.js";
export const powerTriacBta16 = {
    id: "bta16",
    nameTr: "BTA16-600B (TRIAC 600V/16A, TO-220, placeholder)",
    nameEn: "BTA16-600B (TRIAC 600V/16A, TO-220, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: diode.viewBox,
    terminals: diode.terminals,
    defaultLabel: "Q",
    defaultValue: "BTA16-600B",
    schemaType: "diode",
    defaultParams: { saturationCurrent: 1e-12, ideality: 1.5 },
    renderSVG: () => diode.renderSVG(),
};
//# sourceMappingURL=power-triac-bta16.js.map